import React, { memo, useCallback, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import OverviewSection from 'design-system/OverviewSection';
import { sections } from 'features/accounts/constants';
import { selectTotalNetworthBalance } from 'features/accounts/selectors';
import useColors from 'hooks/useColors';
import * as selectors from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import { NETWORTH_PAGE_CONTROL_HEIGHT_WITH_PADDING } from 'features/accounts/values';
import OneMillion from '../OneMillion';
import BankLoginsHelp from './BankLoginsHelp';
import { isWeb } from '../../../../constants';
const NetWorthMainSection = ({ onPressAssets, onPressDebt, blurValues, onContentSizeChange, }) => {
    const colors = useColors();
    const feed = useAppSelector(selectors.selectFeed);
    const zero = useAppSelector(selectors.selectDefaultZeroAmount);
    const totalNetWorth = useAppSelector(selectTotalNetworthBalance);
    const overviewSectionItems = useMemo(() => {
        const netWorth = feed.cards.overview?.netWorth ?? zero;
        const debt = feed.cards.overview?.totalDebt ?? zero;
        const assets = {
            amount: totalNetWorth.amount + debt.amount,
            currency: netWorth.currency,
        }; // TODO: make sure they are of same currency
        const items = [
            {
                title: sections.assets,
                color: colors.text.primary,
                amount: assets,
                blurValue: blurValues,
            },
            {
                title: sections.debt,
                color: colors.text.debt,
                amount: { amount: -debt.amount, currency: debt.currency },
                blurValue: blurValues,
            },
            {
                title: sections.netWorth,
                color: colors.text.brand,
                amount: totalNetWorth,
                blurValue: blurValues,
            },
        ];
        return items;
    }, [
        blurValues,
        colors.text.brand,
        colors.text.debt,
        colors.text.primary,
        feed.cards.overview?.netWorth,
        feed.cards.overview?.totalDebt,
        totalNetWorth,
        zero,
    ]);
    const handlePress = useCallback((section) => {
        if (section === 'Assets') {
            onPressAssets();
        }
        else if (section === 'Debt') {
            onPressDebt();
        }
    }, [onPressAssets, onPressDebt]);
    return (<View onLayout={(e) => onContentSizeChange?.(e.nativeEvent.layout.width, e.nativeEvent.layout.height)} style={styles.container}>
      <OverviewSection items={overviewSectionItems} onPress={handlePress}/>
      <OneMillion />
      <BankLoginsHelp />
    </View>);
};
const styles = StyleSheet.create({
    container: {
        ...(!isWeb && {
            marginTop: NETWORTH_PAGE_CONTROL_HEIGHT_WITH_PADDING,
        }),
    },
});
export default memo(NetWorthMainSection);
